module.exports = __webpack_public_path__ + "static/media/1_A1_22.4ec02443.png";